import type { useGT } from 'gt-react';
import { toast } from 'src/components/ui/toast';

type Gt = ReturnType<typeof useGT>;

export type LeadTimeOverrideTarget = {
  warehouseId: string;
  productV3Key: string;
};

type CreateLeadTimePayload = {
  leadTimeDays: number;
  startsAt?: string;
  endsAt?: string | null;
  reviewAt?: string | null;
  reason?: string | null;
};

export async function runLeadTimeOverrideBulkCreate(
  gt: Gt,
  targets: readonly LeadTimeOverrideTarget[],
  highlightedLineCount: number,
  payload: CreateLeadTimePayload,
  create: (
    input: LeadTimeOverrideTarget & CreateLeadTimePayload,
  ) => Promise<unknown>,
): Promise<{ applied: number; failed: number }> {
  const results = await Promise.allSettled(
    targets.map((t) => create({ ...t, ...payload })),
  );
  const applied = results.filter((r) => r.status === 'fulfilled').length;
  const failed = results.length - applied;
  if (applied > 0) {
    toast.success(
      highlightedLineCount > 1
        ? gt(
            'Total lead time override applied to {series} item×warehouse series ({lines} lines selected)',
            {
              context: 'lead time override bulk toast',
              series: applied,
              lines: highlightedLineCount,
            },
          )
        : gt('Total lead time override created', {
            context: 'lead time override toast',
          }),
    );
  }
  if (failed > 0) {
    toast.error(
      gt('Could not save total lead time override for {n} series.', {
        context: 'lead time override bulk error toast',
        n: failed,
      }),
    );
  }
  return { applied, failed };
}
